var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "card-item min-height-100" }, [
    _c("section", [
      _vm._m(0),
      _c("div", { staticClass: "mb-4" }, [
        _c(
          "section",
          [
            _c(
              "b-field",
              [
                _c(
                  "b-upload",
                  {
                    attrs: { id: "payment-resume-fileUpload" },
                    on: { change: _vm.uploadWalletsEntriesFile },
                    model: {
                      value: _vm.file,
                      callback: function ($$v) {
                        _vm.file = $$v
                      },
                      expression: "file",
                    },
                  },
                  [
                    _c(
                      "a",
                      { staticClass: "button is-primary is-fullwidth" },
                      [
                        _c("b-icon", { attrs: { icon: "upload" } }),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm.file.name ||
                                _vm.$t("transactions.uploadInstructions")
                            )
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]
                ),
              ],
              1
            ),
            !_vm.file.name
              ? _c("p", { staticClass: "is-size-7 has-text-grey" }, [
                  _vm._v("Ningún archivo seleccionado"),
                ])
              : _vm._e(),
            _vm.file.name && !_vm.isFileExtensionValid
              ? _c("p", { staticClass: "is-size-7 has-text-danger" }, [
                  _vm._v(
                    _vm._s(
                      `El archivo que subiste tiene extensión ${_vm.fileType}`
                    )
                  ),
                ])
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "control has-text-right" }, [
        _c(
          "button",
          {
            staticClass: "button is-button-primary",
            attrs: {
              id: "payment-resume-process",
              disabled: _vm.isProcessing || !_vm.isFileExtensionValid,
            },
            on: { click: _vm.processPaymentFile },
          },
          [
            _vm.isProcessing
              ? _c("span", [_c("i", { staticClass: "fas fa-spinner fa-spin" })])
              : _vm._e(),
            !_vm.isProcessing
              ? _c("span", [_vm._v(_vm._s(_vm.$t("transactions.upload")))])
              : _vm._e(),
          ]
        ),
      ]),
      _c(
        "div",
        { staticClass: "control", attrs: { id: "payment-resume-result" } },
        [
          _vm.resultMessage
            ? _c("p", { domProps: { innerHTML: _vm._s(_vm.resultMessage) } })
            : _vm._e(),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "mb-4" }, [
      _c("p", { staticClass: "is-size-6 payment-description" }, [
        _vm._v("Abona saldo para seguro de cesantía, MINVU e Inmobiliarias:"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }